import BaseAPI from '../BaseAPI'

export default class PreferredMealsApi extends BaseAPI {
  constructor () {
    super()
    this._resource = 'recipes'
    this.url = this._baseURL + this.endpoint
  }
}
